import { Spinner, Text, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: tokens.spacingHorizontalS },
  item: { display: 'flex', flexDirection: 'column', gap: '4px', textDecoration: 'none', color: 'inherit' },
  img: { width: '100%', aspectRatio: '4 / 3', objectFit: 'cover', borderRadius: tokens.borderRadiusMedium, border: `1px solid ${tokens.colorNeutralStroke2}`, backgroundColor: tokens.colorNeutralBackground3 },
  caption: { fontSize: tokens.fontSizeBase200, color: tokens.colorNeutralForeground3 },
});

export interface GridPhoto { url: string; caption?: string; onOpen?: () => void }

/** Miniaturas de fotos (URLs firmadas). Al hacer clic se abre la foto en otra pestaña o ejecuta `onOpen`. */
export function AttendancePhotoGrid({ photos, loading, empty }: { photos?: GridPhoto[]; loading?: boolean; empty: string }) {
  const s = useStyles();
  if (loading) return <Spinner size="small" />;
  if (!photos?.length) return <Text className={s.caption}>{empty}</Text>;
  return (
    <div className={s.grid}>
      {photos.map((p, i) => (
        <a
          key={`${p.url}-${i}`}
          className={s.item}
          href={p.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={p.onOpen ? (e) => { e.preventDefault(); p.onOpen!(); } : undefined}
        >
          <img className={s.img} src={p.url} alt={p.caption ?? ''} loading="lazy" />
          {p.caption && <span className={s.caption}>{p.caption}</span>}
        </a>
      ))}
    </div>
  );
}
